function typeahead() {
    $('[data-typeahead-url]:not(.tt-hint)')
        .each(function () {
            const $input = $(this),
                typeahead = $input.data('is-typeaheaded'),
                url = $input.data('typeahead-url'),
                role = $input.data('role');

            if ((typeof typeahead === 'undefined' || !typeahead) && typeof url !== 'undefined' && url) {
                const bloodhound = new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.whitespace,
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    prefetch: {
                        url,
                        filter(tags) {
                            return tags.map(tag => tag.name);
                        }
                    }
                });
                bloodhound.initialize();

                if (typeof role === 'undefined') {
                    $input.typeahead({
                        minLength: 1,
                        highlight: true
                    }, {
                        name: 'bloodhound',
                        limit: 10,
                        source: bloodhound.ttAdapter()
                    });
                } else if (role === 'tagsinput') {
                    $input.tagsinput({
                        maxTags: 3,
                        typeaheadjs: [
                            {
                                minLength: 1,
                                highlight: true
                            }, {
                                name: 'bloodhound',
                                limit: 10,
                                source: bloodhound.ttAdapter()
                            }
                        ]
                    });
                }

                $input.data('is-typeaheaded', true);
                $('input.tt-hint').removeAttr("data-typeahead-url data-val data-val-required data-val-maxlength data-val-maxlength-max");
            }
        });
}

function styleSummary() {
    $('form').each(function () {
        const $this = $(this),
            vse = $this.data('vse');

        if (!vse) {
            $this.data('vse', true);
            $this.submit(function () {
                const validator = $this.data('validator');
                if (!validator || !validator.cancelSubmit) {
                    if (!$this.valid()) {
                        $this.find('.validation-summary-errors').each(function () {
                            $(this).addClass('alert bg-warning alert-styled-left');
                        });
                    }
                }
            });
        }
    });
}

function initializeForm() {
    typeahead();

    if (window.autosize) {
        autosize($('textarea'));
    }

    $('.validation-summary-errors').addClass('alert bg-warning alert-styled-left');

    styleSummary();
}

(() => {
    $(document).on('change', 'select', function () { $(this).trigger('focusout'); }); // fix bootstrap-select 

    initializeForm();

    $(document)
        .ajaxStart(() => {

        })
        .ajaxStop(() => {
            initializeForm();
        });

    $(document).on('reset', 'form', function () {
        const $form = $(this);
        setTimeout(() => $form.find('.js-select').selectpicker('refresh').trigger('change'));

        $form.find("input.js-numeric").each(function () {
            var $input = $(this),
                data = $input.data('bs.numeric');
            data.reset();
        });

        $form.find('.validation-summary-errors').removeClass('alert bg-warning alert-styled-left').html('<ul><li style="display: none;"></li></ul>');
    });

    var is = function (value1, operator, value2, passOnNull) {
        if (passOnNull) {
            const isNullish = (input) => input == null || input == undefined || input == '';

            const value1nullish = isNullish(value1);
            const value2nullish = isNullish(value2);

            if ((value1nullish && !value2nullish) ||
                (value2nullish && !value1nullish) ||
                (value1nullish && value2nullish)) {
                return true;
            }
        }

        const isNumeric = (input) => (input - 0) == input && input.length > 0;

        const isDate = (input) => {
            const dateTest = new RegExp(/(?=\d)^(?:(?!(?:10\D(?:0?[5-9]|1[0-4])\D(?:1582))|(?:0?9\D(?:0?[3-9]|1[0-3])\D(?:1752)))((?:0?[13578]|1[02])|(?:0?[469]|11)(?!\/31)(?!-31)(?!\.31)|(?:0?2(?=.?(?:(?:29.(?!000[04]|(?:(?:1[^0-6]|[2468][^048]|[3579][^26])00))(?:(?:(?:\d\d)(?:[02468][048]|[13579][26])(?!\x20BC))|(?:00(?:42|3[0369]|2[147]|1[258]|09)\x20BC))))))|(?:0?2(?=.(?:(?:\d\D)|(?:[01]\d)|(?:2[0-8])))))([-.\/])(0?[1-9]|[12]\d|3[01])\2(?!0000)((?=(?:00(?:4[0-5]|[0-3]?\d)\x20BC)|(?:\d{4}(?!\x20BC)))\d{4}(?:\x20BC)?)(?:$|(?=\x20\d)\x20))?((?:(?:0?[1-9]|1[012])(?::[0-5]\d){0,2}(?:\x20[aApP][mM]))|(?:[01]\d|2[0-3])(?::[0-5]\d){1,2})?$/);
            return dateTest.test(input);
        };

        const isTime = (input) => /^\d{2}:\d{2}(:\d{2}){0,1}$/.test(input);

        var isBool = (input) => input === true || input === false || typeof input !== "number" && (input.toLowerCase() === 'true' || input.toLowerCase() === 'false');

        if (isDate(value1)) {
            if (isTime(value1)) {
                value1 = parseFloat(value1.replace(':', ''));
                value2 = operator === 'RegExMatch' || operator === 'NotRegExMatch' ? value2 : parseFloat(value2.replace(':', ''));
            } else {
                value1 = Date.parse(value1);
                value2 = operator === 'RegExMatch' || operator === 'NotRegExMatch' ? value2 : Date.parse(value2);
            }
        }
        else if (isTime(value1)) {
            value1 = parseFloat(value1.replace(':', ''));
            value2 = operator === 'RegExMatch' || operator === 'NotRegExMatch' ? value2 : parseFloat(value2.replace(':', ''));
        }
        else if (isBool(value1)) {
            if (value1.toString().toLowerCase() == 'false') value1 = false;
            if (value2.toLowerCase() == 'false') value2 = false;
            value1 = !!value1;
            value2 = operator === 'RegExMatch' || operator === 'NotRegExMatch' ? value2 : !!value2;
        }
        else if (isNumeric(value1)) {
            value1 = parseFloat(value1);
            value2 = operator === 'RegExMatch' || operator === 'NotRegExMatch' ? value2 : parseFloat(value2);
        }

        switch (operator) {
            case 'EqualTo': if (value1 == value2) return true; break;
            case 'NotEqualTo': if (value1 != value2) return true; break;
            case 'GreaterThan': if (value1 > value2) return true; break;
            case 'LessThan': if (value1 < value2) return true; break;
            case 'GreaterThanOrEqualTo': if (value1 >= value2) return true; break;
            case 'LessThanOrEqualTo': if (value1 <= value2) return true; break;
            case 'RegExMatch': return (new RegExp(value2)).test(value1);
            case 'NotRegExMatch': return !(new RegExp(value2)).test(value1);
        }

        return false;
    }

    var setValidationValues = function (options, ruleName, value) {
        options.rules[ruleName] = value;
        if (options.message) {
            options.messages[ruleName] = options.message;
        }
    };
    //var getId = function (element, dependentProperty) {
    //    var pos = element.id.lastIndexOf('_') + 1;
    //    return element.id.substr(0, pos) + dependentProperty.replace(/\./g, '_');
    //};

    const range = $.validator.methods.range;
    $.validator.methods.range = function (value, element, param) {
        if (element.type === 'checkbox') {
            return element.checked;
        } else {
            const $element = $(element),
                data = $element.data('bs.numeric');
            return range.call(this, data ? AutoNumeric.unformat($element[0], data._config) : value, element, param);
            //return range.call(this, data ? data.getNumber() : value, element, param);
        }
    }
    const number = $.validator.methods.number;
    $.validator.methods.number = function (value, element) {
        const $element = $(element),
            data = $element.data('bs.numeric');

        return number.call(this, data ? data.getNumber() : value, element);
    }

    $.validator.unobtrusive.options = {
        invalidHandler(event, validator) {
            setTimeout(() => {
                $(validator.currentForm).find('.js-numeric:input').each(function () {
                    $(this).data('bs.numeric').reformat();
                });
            }, 500);
        }
    }

    $.validator.setDefaults({
        ignore: 'input[type=hidden],.ignore,.note-editable.panel-body', // fixes hidden select
        onfocusout(element) {
            if (!this.checkable(element) && (element.name in this.submitted || !this.optional(element))) {
                this.element(element);
            } else {
                if (element.nodeName.toLowerCase() === 'select' && $(element).data('val-required') && !$(element).val()) {
                    this.element(element);
                }
            }
        },
        errorElement: 'span',
        errorClass: 'help-bock',
        errorPlacement(error, element) {
            error.insertAfter(element.parent('.input-group').length || element.prop('type') === 'checkbox' || element.prop('type') === 'radio' ? element.parent() : element);
        },
        highlight(element) {
            const $element = $(element),
                $formGroup = $element.closest('.form-group');
            let hasError = $formGroup.data('has-error');

            if (hasError === undefined) {
                hasError = {};
                $formGroup.find('input[data-val=true],textarea[data-val=true],select[data-val=true]').each(function () {
                    hasError[$(this).attr('id')] = false;
                });
            }

            hasError[$element.attr('id')] = true;

            $formGroup.data('has-error', hasError).addClass('has-error');
            if ($element.hasClass('js-form-detail-answer') || $element.hasClass('js-was-property-visited') || $element.hasClass('js-unable-to-visit-reason') || $element.hasClass('js-bad-address-reason') || $element.hasClass('js-bad-address-source') || $element.hasClass('js-no-access-reason')) {
                $element.closest('.panel-heading').addClass('has-error');
            }
        },
        unhighlight(element) {
            const $element = $(element),
                $formGroup = $element.closest('.form-group');
            let hasError = $formGroup.data('has-error');

            if (hasError === undefined) {
                hasError = {};
                $formGroup.find('input[data-val=true],textarea[data-val=true],select[data-val=true]').each(function () {
                    hasError[$(this).attr('id')] = false;
                });
            }

            hasError[$element.attr('id')] = false;
            $formGroup.data('has-error', hasError);

            let isAllValid = true;
            for (let key in hasError) {
                if (hasError.hasOwnProperty(key) && hasError[key]) {
                    isAllValid = false;
                    break;
                }
            }

            if (isAllValid) {
                $formGroup.removeClass('has-error');
                if ($element.hasClass('js-form-detail-answer') || $element.hasClass('js-was-property-visited') || $element.hasClass('js-unable-to-visit-reason') || $element.hasClass('js-bad-address-reason') || $element.hasClass('js-bad-address-source') || $element.hasClass('js-no-access-reason')) {
                    $element.closest('.panel-heading').removeClass('has-error');
                }
            }
        }
    });

    $.validator.addMethod("is", function (value, element, params) {
        const dependentProperty = params[2];
        const operator = params[3];
        const passOnNull = params[4];
        var $form = $(element).parents("form");

        let dependentValue = $form.find(`[name="${dependentProperty}"]`).get(0).value;

        if ($(element).data('bs.numeric')) {
            value = $(element).data('bs.numeric').getNumber();
            let dependentElement = $form.find(`[name="${dependentProperty}"]`);

            if (dependentElement.data('bs.numeric')) {
                dependentValue = parseFloat(dependentElement.data('bs.numeric').getNumber());
            } else {
                dependentValue = parseFloat(dependentValue);
            }
        }

        return is(value, operator, dependentValue, passOnNull);
    });

    $.validator.addMethod("requiredif", function (value, element, params) {
        const dependentProperty = params[3];
        const dependentTestValue = params[2];
        const operator = params[4];
        const pattern = params[5];
        const dependentPropertyElement = element.form.elements[dependentProperty];
        var dependentValue = null;

        if (!dependentPropertyElement.tagName && dependentPropertyElement.length > 1) {
            for (var index = 0; index != dependentPropertyElement.length; index++)
                if (dependentPropertyElement[index]['checked']) {
                    dependentValue = dependentPropertyElement[index].value;
                    break;
                }

            if (dependentValue == null)
                dependentValue = false;
        } else {
            const data = $(dependentPropertyElement).data('bs.numeric');
            if (data) {
                dependentValue = data.getNumber();
            } else {
                dependentValue = dependentPropertyElement.value;
            }
        }

        if (is(dependentValue, operator, dependentTestValue)) {
            if (pattern == null) {
                const data = $(element).data('bs.numeric');
                value = data ? data._autoNumeric.getNumericString() : value;
                if (value != null && value.toString().replace(/^\s\s*/, '').replace(/\s\s*$/, '') != '')
                    return true;
            } else {
                return (new RegExp(pattern)).test(value);
            }
        } else {
            return true;
        }

        return false;
    });

    $.validator.addMethod('requiredifempty', function (value, element, params) {
        const dependentProperty = params[2];
        const dependentValue = document.getElementById(dependentProperty).value;

        if (dependentValue == null || dependentValue.toString().replace(/^\s\s*/, '').replace(/\s\s*$/, '') == '') {
            if (value != null && value.toString().replace(/^\s\s*/, '').replace(/\s\s*$/, '') != '') {
                return true;
            }
        } else {
            return true;
        }

        return false;
    });

    $.validator.addMethod('requiredifnotempty', function (value, element, params) {
        const dependentProperty = params[2];
        const dependentValue = document.getElementById(dependentProperty).value;

        if (dependentValue != null && dependentValue.toString().replace(/^\s\s*/, '').replace(/\s\s*$/, '') != '') {
            if (value != null && value.toString().replace(/^\s\s*/, '').replace(/\s\s*$/, '') != '')
                return true;
        }
        else
            return true;

        return false;
    });

    // adding async for remote since we're seeing race condition with an ajax form submit
    var index = $.validator.unobtrusive.adapters.findIndex(adapter => adapter.name === 'remote');
    if (index > -1) {
        $.validator.unobtrusive.adapters.splice(index, 1);
    }

    $.validator.unobtrusive.adapters.add('remote', ['url', 'type', 'async', 'additionalfields'], function (options) {
        var value = {
            url: options.params.url,
            type: options.params.type || 'GET',
            async: options.params.async == null ? true : (options.params.async == 'true'),
            data: {}
        },
            prefix = options.element.name.substr(0, options.element.name.lastIndexOf('.') + 1);

        $.each((options.params.additionalfields || options.element.name).replace(/^\s+|\s+$/g, '').split(/\s*,\s*/g), function (i, fieldName) {
            var paramName = fieldName;
            if (fieldName.indexOf('*.') === 0) {
                paramName = fieldName.replace('*.', prefix);
            }

            value.data[paramName] = function () {
                var field = $(options.form).find(':input').filter("[name='" + paramName.replace(/([!"#$%&'()*+,./:;<=>?@\[\\\]^`{|}~])/g, "\\$1") + "']");
                // For checkboxes and radio buttons, only pick up values from checked fields.
                if (field.is(':checkbox')) {
                    return field.filter(':checked').val() || field.filter(':hidden').val() || '';
                }
                else if (field.is(':radio')) {
                    return field.filter(':checked').val() || '';
                }
                return field.val();
            };
        });

        setValidationValues(options, 'remote', value);
    });

    $.validator.unobtrusive.adapters.add("is", ["dependentproperty", "operator", "passonnull"], function (options) {
        let displayName = null;

        if (options.element.labels && options.element.labels[0]) {
            displayName = options.element.labels[0].innerHTML;
        }

        displayName = displayName || options.element.name;
        let dependentDisplayName = null;
        let dependentProperty = dependentProperty = $(options.element).closest('form').find(`[name="${dependentProperty}"]`);
        if (dependentProperty.length) {
            dependentProperty = $(options.element).closest('form').find('#' + options.params.dependentproperty);
        }

        if (dependentProperty && dependentProperty[0] && dependentProperty[0].labels && dependentProperty[0].labels[0]) {
            dependentDisplayName = dependentProperty[0].labels[0].innerHTML;
        }

        dependentDisplayName = dependentDisplayName || options.params.dependentproperty;

        setValidationValues(options, "is", [
            displayName,
            dependentDisplayName,
            options.params.dependentproperty,
            options.params.operator,
            options.params.passonnull]);
    });

    $.validator.unobtrusive.adapters.add("requiredif", ["dependentproperty", "dependentvalue", "operator", "pattern"], function (options) {
        let displayName = null;

        if (options.element.labels && options.element.labels[0]) {
            displayName = options.element.labels[0].innerHTML;
        }

        displayName = displayName || options.element.name;
        let dependentDisplayName = $(`label[for="${options.params.dependentproperty}"]`).text()
            || options.params.dependentproperty;

        setValidationValues(options, "requiredif", [displayName, dependentDisplayName, options.params.dependentvalue, options.params.dependentproperty, options.params.operator, options.params.pattern]);
    });

    $.validator.unobtrusive.adapters.add('requiredifempty', ['dependentproperty'], function (options) {
        let displayName = null;

        if (options.element.labels && options.element.labels[0]) {
            displayName = options.element.labels[0].innerHTML;
        }

        displayName = displayName || options.element.name;
        let dependentDisplayName = null;
        let dependentProperty = $('#' + options.params.dependentproperty);

        if (dependentProperty && dependentProperty[0] && dependentProperty[0].labels && dependentProperty[0].labels[0]) {
            dependentDisplayName = dependentProperty[0].labels[0].innerHTML;
        }

        dependentDisplayName = dependentDisplayName || options.params.dependentproperty;

        setValidationValues(options, 'requiredifempty', [displayName, dependentDisplayName, options.params.dependentproperty]);
    });

    $.validator.unobtrusive.adapters.add('requiredifnotempty', ['dependentproperty'], function (options) {
        let displayName = null;

        if (options.element.labels && options.element.labels[0]) {
            displayName = options.element.labels[0].innerHTML;
        }

        displayName = displayName || options.element.name;

        let dependentDisplayName = null;
        const dependentProperty = $('#' + options.params.dependentproperty);

        if (dependentProperty && dependentProperty[0] && dependentProperty[0].labels && dependentProperty[0].labels[0]) {
            dependentDisplayName = dependentProperty[0].labels[0].innerHTML;
        }

        dependentDisplayName = dependentDisplayName || options.params.dependentproperty;

        setValidationValues(options, 'requiredifnotempty', [displayName, dependentDisplayName, options.params.dependentproperty]);
    });

    // Validate Rule Expression
    $.validator.addMethod("ruleexpression", function (value, element) {
        let count = 0;
        for (let i = 0; i < value.length; i++) {
            if (value[i] === '(') {
                count++;
            } else if (value[i] === ')') {
                count--;
            }
        }
        return count === 0;
    });
    $.validator.unobtrusive.adapters.add("ruleexpression", function (options) {
        let displayName = null;

        if (options.element.labels && options.element.labels[0]) {
            displayName = options.element.labels[0].innerHTML;
        }

        displayName = displayName || options.element.name;

        options.rules['ruleexpression'] = [displayName, true];
        options.messages['ruleexpression'] = options.message;
    });


    // Date Greater Than
    $.validator.addMethod('dategreaterthan',
        function (value, element, parameters) {
            const paramSettings = parameters[2];
            let othervalue = $('#' + paramSettings.dependentproperty).val();
            othervalue = (othervalue === null || othervalue === undefined ? '' : othervalue).toString().toLowerCase();

            let isValid = true;

            if (!/Invalid|NaN/.test(new Date(value)) && !/Invalid|NaN/.test(new Date(othervalue))) {
                if (new Date(value) <= new Date(othervalue)) {
                    isValid = false;
                }
            }
            else if (!/Invalid|NaN/.test(new Date('1/1/2000 ' + value)) && !/Invalid|NaN/.test(new Date('1/1/2000 ' + value))) {
                if (new Date('1/1/2000 ' + value) <= new Date('1/1/2000 ' + othervalue)) {
                    isValid = false;
                }
            } else {
                isValid = false;
            }

            return isValid;
        });
    $.validator.unobtrusive.adapters.add("dategreaterthan", ["dependentproperty"], function (options) {
        let displayName = null;

        if (options.element.labels && options.element.labels[0]) {
            displayName = options.element.labels[0].innerHTML;
        }

        displayName = displayName || options.element.name;

        let dependentDisplayName = null;
        const dependentProperty = $('#' + options.params.dependentproperty);

        if (dependentProperty && dependentProperty[0] && dependentProperty[0].labels && dependentProperty[0].labels[0]) {
            dependentDisplayName = dependentProperty[0].labels[0].innerHTML;
        }

        dependentDisplayName = dependentDisplayName || options.params.dependentproperty;

        options.rules['dategreaterthan'] = [displayName, dependentDisplayName, options.params];
        options.messages['dategreaterthan'] = options.message;
    });

    // date range
    $.validator.addMethod("daterange", function (value, element, params) {
        var tokenizer = value.split('-');
        if (tokenizer.length !== 2) {
            return false;
        }
        if (!moment(tokenizer[0].trim(), "MM/dd/yyyy").isValid() || !moment(tokenizer[1].trim(), "MM/dd/yyyy").isValid()) {
            return false;
        }
        if (moment(tokenizer[1].trim()).isBefore(moment(tokenizer[0].trim()))) {
            return false;
        }

        return true;
    });

    $.validator.unobtrusive.adapters.add("daterange", function (options) {
        let displayName = null;

        if (options.element.labels && options.element.labels[0]) {
            displayName = options.element.labels[0].innerHTML;
        }

        displayName = displayName || options.element.name;

        options.rules["daterange"] = [displayName, options.element.value];
        options.messages["daterange"] = options.message;
    });

    // File Form Extensions

    $.validator.addMethod('formfileextensions',
        function (value, element, parameters) {
            var isValid = true;
            const allowedTypes = parameters[1].split(',').map((item) => item.trim().toLowerCase());

            if (element.files === undefined ||
                element.files === null ||
                allowedTypes === undefined ||
                allowedTypes === null) {
                return true; // fallback to server validation
            }


            for (let i = 0; i < element.files.length; i++) {
                const fileName = element.files[i].name;
                const extension = fileName.substr(fileName.lastIndexOf('.')).toLowerCase();

                if ($.inArray(extension, allowedTypes) < 0) {
                    isValid = false;
                }

            }

            return isValid;
        });
    $.validator.unobtrusive.adapters.add("formfileextensions", ["extensions"], function (options) {
        let displayName = null;

        if (options.element.labels && options.element.labels[0]) {
            displayName = options.element.labels[0].innerHTML;
        }

        displayName = displayName || options.element.name;

        options.rules['formfileextensions'] = [displayName, options.params["extensions"]];
        options.messages['formfileextensions'] = options.message;
    });

    $.validator.addMethod('comparevalue', function (value, element, parameters) {
        switch (parameters.comparison) {
            case 2:
                return value !== parameters.value;
            case 3:
                return value > parameters.value;
            case 4:
                return value < parameters.value;
            case 5:
                return value >= parameters.value;
            case 6:
                return value <= parameters.value;
            default:
                return value === parameters.value;
        }
    });

    $.validator.unobtrusive.adapters.add('comparevalue', ['comparison', 'value'], function (options) {
        let displayName = null;

        if (options.element.labels && options.element.labels[0]) {
            displayName = options.element.labels[0].innerHTML;
        }

        displayName = displayName || options.element.name;

        options.rules['comparevalue'] = {
            displayName,
            comparison: parseInt(options.params.comparison, 10),
            value: options.params.value
        };
        options.messages['comparevalue'] = options.message;
    });

    $.fn.clearValidation = function () {
        var validator = $(this).validate();
        $('[name]', this).each(function () {
            validator.successList.push(this);
            validator.showErrors();
        });
        validator.resetForm();
        validator.reset();
    };

    $(".input-validation-error").each(function (i, element) {
        const $element = $(element);
        if ($element.closest('.form-group').hasClass('has-error') == false) {
            $element.closest('.form-group').addClass('has-error');
        }
        if ($element.hasClass('js-form-detail-answer')) {
            if ($element.closest('.panel-heading').hasClass('has-error') == false) {
                $element.closest('.panel-heading').addClass('has-error');
            }
        }
    });
})();

function resetValidation(form) {
    $(form).removeData('unobtrusiveValidation validator');
    $.validator.unobtrusive.parse(form);
}